//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import StockInventoryTasks from '../../pages/main/sections/Stock/StockInventoryTasks.vue'

export default {
  name: 'StockCardSectionInventoryTasks',
  components: {
    SectionWithFilter,
    StockInventoryTasks
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    const formId = 'stockCardInventoryTasks'

    return {
      loading: false,

      formId: formId,
      filterConfig: {
        filterName: 'ФИЛЬТР ЗАЯВОК НА ИНВЕНТАРИЗАЦИЮ',
        filterType: 'stockInventoryRequest',
        filterFormId: formId,
        filterUnavailable: false
      }
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    },
    onLoadingChange: function (value) {
      this.loading = value
    }
  }
}
